export default {
  meta: {
    title: $localize`:@@meta.crash.history.title:История игр Crash`,
    description: $localize`:@@meta.crash.history.desc:Мы очень постарались и сгенерировали самые высокие коэффициенты для вас. Проверьте на этой странице, Вы точно не будете разочарованы!`
  }
};